import { Button } from "./ui/button";
import { Phone, Calendar, Calculator } from "lucide-react";

const MobileStickyCTA = () => {
  const scrollToROI = () => {
    const roiSection = document.getElementById('neil-roi');
    if (roiSection) {
      roiSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="fixed bottom-3 left-3 right-3 z-50 flex gap-2 md:hidden">
      <a href="tel:+13369624539" className="flex-1">
        <Button
          size="sm"
          className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-bold rounded-xl shadow-2xl flex items-center justify-center gap-2"
        >
          <Phone className="h-4 w-4" />
          Call
        </Button>
      </a>
      
      <a href="https://api.leadconnectorhq.com/widget/bookings/neilaipudurobotics" target="_blank" rel="noopener noreferrer" className="flex-1">
        <Button
          size="sm"
          className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-bold rounded-xl shadow-2xl flex items-center justify-center gap-2 shadow-[0_0_20px_rgba(0,255,200,0.4)]"
        >
          <Calendar className="h-4 w-4" />
          Book Demo
        </Button>
      </a>
      
      <Button
        size="sm"
        onClick={scrollToROI}
        className="flex-1 glass-effect border border-[hsl(var(--line))] hover:bg-white/10 font-bold rounded-xl shadow-2xl"
      >
        <Calculator className="h-4 w-4" />
        ROI
      </Button>
    </div>
  );
};

export default MobileStickyCTA;
